export default __webpack_public_path__ + "static/terminal-presintation-5109ccf2fa52f5f105e4d20a97234040.png";